'use strict';

module.exports = {
    CREATED: 'endpoint.created',
    DELETED: 'endpoint.deleted',
    MODIFIED: 'endpoint.modified',
    ONLINE: 'endpoint.online',
    OFFLINE: 'endpoint.offline'
};